import { render } from "./CategoryTreeItem.vue?vue&type=template&id=59028f45&scoped=true"
import script from "./CategoryTreeItem.vue?vue&type=script&lang=js"
export * from "./CategoryTreeItem.vue?vue&type=script&lang=js"

import "./CategoryTreeItem.vue?vue&type=style&index=0&id=59028f45&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59028f45"

export default script